@import '@alfalab/core-components-vars/src/index.css';
@import '../../input/src/components/base-input/inverted.module.css';
@import '../../form-control/src/vars.css';

.textarea {
    color: var(--input-inverted-color);
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.textarea::placeholder {
    color: var(--input-inverted-placeholder-color);
}

.hasInnerLabel::placeholder {
    color: var(--input-inverted-with-label-placeholder-color);
}

/* DISABLED STATE */

.textarea:disabled {
    color: var(--input-inverted-disabled-color);
    -webkit-text-fill-color: var(--input-inverted-disabled-color);
}

/* READ-ONLY STATE */

.textarea:read-only {
    color: var(--input-inverted-read-only-color);
}

/* FOCUS STATE */

.textarea:focus::placeholder {
    color: var(--input-inverted-focus-placeholder-color);
}

.hint {
    color: var(--form-control-hint-color);
}
.error {
    color: var(--form-control-error-color);
}
